
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.63 20.13"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1"}},[_c('path',{attrs:{"data-name":"Path 225","d":"M19.63 10.36A11.18 11.18 0 0119 14.2a9.45 9.45 0 01-2.06 3.33 8.25 8.25 0 01-3.34 2 12.88 12.88 0 01-3.85.58 12.15 12.15 0 01-3.83-.58 8.73 8.73 0 01-3.34-2 8 8 0 01-2-3.32 13.15 13.15 0 01-.58-3.8 9.82 9.82 0 01.68-3.82 9.7 9.7 0 012.18-3.23A13.69 13.69 0 015.94 1 8.15 8.15 0 017.78.23a6.9 6.9 0 012-.23 8.79 8.79 0 013.78 1 11.89 11.89 0 013.04 2.38 11.53 11.53 0 012.15 3.2 9.3 9.3 0 01.88 3.78z"}})])])])
          )
        }
      }
    